'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'car-side';
var width = 640;
var height = 512;
var aliases = [128663];
var unicode = 'f5e4';
var svgPathData = 'M161.1 80l78.9 0 0 112-138.1 0 36.8-96.5c3.5-9.3 12.5-15.5 22.4-15.5zM288 192l0-112 72.2 0c7.5 0 14.6 3.5 19.1 9.5L457.4 192 288 192zm229.9 .1L417.5 60.4C403.9 42.5 382.7 32 360.2 32L161.1 32c-29.9 0-56.6 18.4-67.3 46.4L49.9 193.6C21.3 200 0 225.5 0 256l0 80c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l144.7 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l16.4 0c35.3 0 64-28.7 64-64l0-16c0-68.7-54.2-124.8-122.1-127.9zM550.4 352c-14.6-28.5-44.2-48-78.4-48s-63.8 19.5-78.4 48l-163.2 0c-14.6-28.5-44.2-48-78.4-48s-63.8 19.5-78.4 48L64 352c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l448 0c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16l-25.6 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarSide = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;